<template>
<div class="chapter">
<div class="inner_page">
<p class="p0"><span class="t2">Rotten Fruit</span></p>
<p class="p0">By Eve Francis</p>
<p><a id="a5"></a><a href="#/005#a12">Chapter 1</a></p>
<p><span href="#/006#a13" title="Link target outside of Sample">Chapter 2</span></p>
<p><span href="#/007#a14" title="Link target outside of Sample">Chapter 3</span></p>
<p><span href="#/008#a15" title="Link target outside of Sample">Chapter 4</span></p>
<p><span href="#/009#a16" title="Link target outside of Sample">Chapter 5</span></p>
<p><span href="#/010#a17" title="Link target outside of Sample">Chapter 6</span></p>
<p><span href="#/011#a18" title="Link target outside of Sample">Chapter 7</span></p>
<p> </p>
<p class="p0"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004.vue?49e6c5c9